// extracted by mini-css-extract-plugin
export var section = "styles-module--section--2J4vC";
export var inner = "styles-module--inner--2Udoc";
export var tags = "styles-module--tags--197_n";
export var tagItem = "styles-module--tagItem--yfw4L";
export var title = "styles-module--title--2f8tV";
export var subtitle = "styles-module--subtitle--kblT8";
export var date = "styles-module--date--3VwxQ";